import React from "react";
import { Card } from "../../../../shared/components/ui/Card";
import { InfoField } from "../../../../shared/components/ui/InfoField";
import type { PoolRegulation } from "../../../../api/client/types/catalog.types";
import type { InterventionLevel } from "../../../../api/client/types/catalog.types";

interface PoolRegulationNewDetailFieldsProps {
  poolRegulation: PoolRegulation | null;
  interventionLevel: InterventionLevel | null;
}

/**
 * PoolRegulationNewDetailFields
 * Renders only the pool regulation-specific detail fields in read-only format.
 * Designed to be used within a parent detail component that handles common fields.
 */
export const PoolRegulationNewDetailFields: React.FC<
  PoolRegulationNewDetailFieldsProps
> = ({ poolRegulation, interventionLevel }) => {
  return (
    <Card variant="formSection">
      <h2 className="text-lg font-medium text-gray-800 mb-4">
        Información de Incumplimiento de Reglamento
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InfoField
          label="Tipo de Incumplimiento"
          value={poolRegulation?.name}
        />
        <InfoField
          label="Nivel de Intervención"
          value={interventionLevel?.name}
        />
      </div>
    </Card>
  );
};

